import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'customCurrency',
    standalone: true
})
export class CustomCurrencyPipe implements PipeTransform {
    private currencyPipe = inject(CurrencyPipe);

    transform(value: number | null | undefined): string | null {
        if (value === null) {
            return null;
        }
        return this.currencyPipe.transform(value, 'EUR', 'symbol', '1.2-2');
    }
}
